import React from "react";
import "./enlargeable-image.css";
import { AnalyticImage } from "./analytic-image";
import { ENLARGED_IMAGE_TOP_PADDING, ENLARGED_IMAGE_LEFT_PADDING } from "./constants";
import { sendProxyDiscordRequest, bufferToBase64Image } from "./utils";

export default class EnlargeableImage extends React.Component {
  constructor(props) {
    super(props);

    // The size is rendered straight from props rather than mirrored into state:
    // the parent measures the laid out result right after it sets a size, so the
    // image has to reach the DOM in the parent's own commit.
    this.state = {
      src: props.src,
      proxyDiscordSrc: props.proxyDiscordSrc,
      isEnlarged: false,
    };

    if (!props.src && props.proxyDiscordSrc) {
      this.getProxiedDiscordImage(props.proxyDiscordSrc);
    }
  }

  getProxiedDiscordImage(proxyDiscordSrc) {
    sendProxyDiscordRequest(proxyDiscordSrc, /* params= */ undefined, /* isImage= */ true).then(
      (res) => {
        this.state.src = bufferToBase64Image(res.data);
        this.setState(this.state);
      }
    );
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.src !== prevProps.src ||
      this.props.proxyDiscordSrc !== prevProps.proxyDiscordSrc
    ) {
      this.state.src = this.props.src;
      this.state.proxyDiscordSrc = this.props.proxyDiscordSrc;
      if (!this.props.src && this.props.proxyDiscordSrc) {
        this.getProxiedDiscordImage(this.props.proxyDiscordSrc);
      } else {
        this.setState(this.state);
      }
    }
  }

  showLargeImageOverlay(e) {
    this.state.targetImage = e.target;
    this.state.isEnlarged = true;
    this.setState(this.state);
  }

  hideLargeImageOverlay(e) {
    if (e.target.id === "chart-enlarged") {
      return;
    }
    this.state.isEnlarged = false;
    this.setState(this.state);
  }

  onKeyDown(e) {
    if (e.key === "Escape") {
      this.state.isEnlarged = false;
      this.setState(this.state);
    }
  }

  renderLargeImageOverlay() {
    const widthRatio =
      (window.innerWidth - ENLARGED_IMAGE_LEFT_PADDING * 2) / this.state.targetImage.clientWidth;
    const heightRatio =
      (window.innerHeight - ENLARGED_IMAGE_TOP_PADDING * 2) / this.state.targetImage.clientHeight;
    const ratio = Math.min(widthRatio, heightRatio);
    const enlargedWidth = this.state.targetImage.clientWidth * ratio;
    const enlargedHeight = this.state.targetImage.clientHeight * ratio;
    return (
      <div
        className="chart-overlay"
        onClick={(e) => this.hideLargeImageOverlay(e)}
        onKeyDown={(e) => this.onKeyDown(e)}
        tabIndex="0"
      >
        <AnalyticImage
          id="chart-enlarged"
          width={enlargedWidth}
          height={enlargedHeight}
          src={this.state.src}
        />
      </div>
    );
  }

  render() {
    if (!this.state.src) {
      return <div />; // Empty page
    }
    return (
      <div>
        <img
          className="enlargeable-image"
          width={this.props.width}
          height={this.props.height}
          src={this.state.src}
          // Lets a parent size itself from the intrinsic dimensions without
          // fetching the image a second time to measure it.
          onLoad={this.props.onLoad}
          onClick={(e) => this.showLargeImageOverlay(e)}
        />
        {this.state.isEnlarged && this.renderLargeImageOverlay()}
      </div>
    );
  }
}
